/**
 * Converts a Date or "HH:mm" string to ISO string with a fake date (2000-01-01) to match backend format.
 * @param value Date | string | null - Date object or "HH:mm" string
 * @returns string | null - ISO string e.g. "2000-01-01T01:30:00Z", or null if input is null
 */
export function formatTimeToISO(value: Date | string | null): string | null {
  if (!value) return null;

  let hours = 0;
  let minutes = 0;
  let date: Date;

  if (typeof value === "string") {
    [hours, minutes] = value.split(":").map(Number);
    // Create a new Date with fake date and extracted time
    date = new Date(2000, 0, 1, hours, minutes, 0);
  } else {
    date = new Date(value);
    date.setSeconds(0, 0);
  }

  return date.toISOString(); // ISO in UTC
}

/**
 * Converts an ISO datetime string to "HH:mm"
 * Respects the timezone inside the ISO string.
 */
export function formatISOToTime(isoString: string | null): string {
  if (!isoString) return "";

  const date = new Date(isoString);

  const pad = (n: number) => n.toString().padStart(2, "0");

  const hours = date.getHours();
  const minutes = date.getMinutes();

  return `${pad(hours)}:${pad(minutes)}`;
}
